var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"sahabat-zx"}},[_c('img',{staticClass:"w-8 mx-4 mt-1",attrs:{"src":"/assets/images/sahabat-zx/charity.svg","alt":"charity","title":"Sahabat ZX"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }